import styled from "styled-components";

const DisplayNameText = styled.p`
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default DisplayNameText;